import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSettingsComponent } from "./med-icon-settings.component";

@NgModule({
  declarations: [
    MedIconSettingsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSettingsComponent,
  ],
})
export class MedIconSettingsModule { }
